// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"09d3060b","758":"09d3060b","959":"09d3060b"}[chunkId] + ".chunk.css";
};